import { render } from "./FileUploadComponent.vue?vue&type=template&id=c17062a2&scoped=true"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js"

import "./FileUploadComponent.vue?vue&type=style&index=0&id=c17062a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c17062a2"]])

export default __exports__